import { useCallback } from "react";
import {
  getGridDateOperators,
  getGridSingleSelectOperators,
  getGridStringOperators,
} from "@mui/x-data-grid-pro";
import __ from "src/utils/Translations";

export const useTableOperators = () => {
  const getStringOperators = useCallback(
    ({ labelUT }: { labelUT: string }) =>
      getGridStringOperators().map((operator) => {
        if (operator.value === "contains") {
          return {
            ...operator,
            headerLabel: __(labelUT),
          };
        }

        return operator;
      }),
    []
  );

  const getDateOperators = useCallback(
    ({ labelUT }: { labelUT: string }) =>
      getGridDateOperators().map((operator) => {
        if (operator.value === "is") {
          return {
            ...operator,
            headerLabel: __(labelUT),
          };
        }
        return operator;
      }),
    []
  );

  const getSelectOperators = useCallback(
    ({ labelUT }: { labelUT: string }) =>
      getGridSingleSelectOperators().map((operator) => {
        if (operator.value === "is") {
          return {
            ...operator,
            headerLabel: __(labelUT),
          };
        }

        return operator;
      }),
    []
  );

  return { getStringOperators, getSelectOperators, getDateOperators };
};
